import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../components/design/buttons/Button';
import Card from '../../components/design/cards/card';
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import SelectType from './pages/SelectType';
import Providers from './pages/Providers';
import Plans from './pages/Plans';
import Login from './pages/Login';
import IdentitiyCheck from './pages/IdentitiyCheck';
import NumberTpye from './pages/NumberType';
import NumberCostumOrListOrTransfer from './pages/NumberCostumOrListOrTransfer';
import Check from './pages/Check';
import './Page.css'
import { Info } from '../store/components/PlanItem';
import { ShimmerTitle } from "react-shimmer-effects";
import SideInfo from './components/sideInfo';
import { getPlanbyId } from "../../services/stepper.service";
import { getProvider } from '../../services/providers.service';
import { roundUpToTwoDecimals } from '../../tools/AssetHelpers';
import { CheckoutStep, trackCheckoutProgress } from '../../tools/tracking';
import { getResellerPlanId, resetCorrelationId, setContractType } from '../../services/sim.service';
import Payment from './pages/Payment';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import Rs from '../../components/design/rs';

interface ObjectArray {
    onOptionSelect: (obj: { [key: string]: any }, next?: boolean) => void;
    t: any;
    i18n: any;
    objs?: any;
}

const stepName = (component: any): CheckoutStep | null => {
    if (component === NumberCostumOrListOrTransfer) return 'number_selection';
    if (component === IdentitiyCheck) return 'personal_info';
    if (component === Check) return 'otp_verification';
    if (component === Payment) return 'payment';
    return null;
};

const Page = () => {
    const { t, i18n } = useTranslation();
    const [currentStep, setCurrentStep] = useState(0);
    const [objs, setObjs] = useState<any>({ number_type: 'new' });
    const [isLoading, setIsLoading] = useState(true);
    const [plan, setPlan] = useState<any>();
    const [provider, SetProvider] = useState<any>();
    const [showServiceFeesInfo, setShowServiceFeesInfo] = useState(false);
    const user = localStorage.getItem('tygo_user');
    const token = JSON.parse(user!) && JSON.parse(user!).token;
    const correlationResetRef = useRef(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        // Only an explicit "true" means port-in. The param is absent for a new
        // number, and used to come back from the login round-trip as the string
        // "null" — which is truthy and dropped the customer into port-in.
        const bringNumber = urlParams.get('bringNumber') === 'true';
        const planId = urlParams.get('id');
        const requiresNumberReservation = urlParams.get('requiresNumberReservation');
        const checkoutId = urlParams.get('checkoutId');

        if (!token) {
            // Built from the params that are actually set, and encoded so they
            // stay part of the redirect target instead of leaking onto /login2.
            const redirectParams = new URLSearchParams();
            if (planId) redirectParams.set('id', planId);
            if (bringNumber) redirectParams.set('bringNumber', 'true');
            if (requiresNumberReservation !== null) redirectParams.set('requiresNumberReservation', requiresNumberReservation);
            const target = `/sim?${redirectParams.toString()}`;
            window.location.href = `/login2?redirect=${encodeURIComponent(target)}`;
            return;
        }


        if (bringNumber) {
            setObjs(prevObjs => {
                // Only the landing tab of the number step — on a plan that
                // accepts MNP the customer can switch back to a new number,
                // which flips this flag back off.
                const newObjs = { ...prevObjs, bringNumber: true };
                return newObjs;
            });
            setSteps([
                { component: SelectType, title: t('local_sim.select_type.title') },
                { component: NumberCostumOrListOrTransfer, title: t('local_sim.number.transfer.title') },
                { component: IdentitiyCheck, title: t('steps.personal_info') },
                { component: Check, title: t('steps.personal_info') },
                { component: Payment, title: t('steps.personal_info') },
            ]);
        }


        if (requiresNumberReservation === "false") {
            setObjs(prevObjs => {
                const newObjs = { ...prevObjs, requiresNumberReservation: true };
                return newObjs;
            });
            setSteps([
                { component: IdentitiyCheck, title: t('steps.personal_info') },
                { component: Check, title: t('steps.personal_info') },
                { component: Payment, title: t('steps.personal_info') },
            ]);
        }

        const fetchPlan = async () => {
            getPlanbyId(planId, i18n.language).then(async (a: any) => {

                setPlan(a.data.returnData);
                // recorded up front so every SIM MS call in the flow carries X-CONTRACT-TYPE
                setContractType(a.data.returnData.contractTypeId);
                const providerId = a.data.returnData.providerId;
                const simTypeId = a.data.returnData.simTypeId;
                if (simTypeId === "1") {
                    setObjs(prevObjs => {
                        const newObjs = { ...prevObjs, type: "sim" }
                        return newObjs;
                    });
                    // remove the first step
                    if (requiresNumberReservation === "false") {
                        setSteps([
                            { component: IdentitiyCheck, title: t('steps.personal_info') },
                            { component: Check, title: t('steps.personal_info') },
                            { component: Payment, title: t('steps.personal_info') },
                        ]);
                    } else {
                        setSteps([
                            { component: NumberCostumOrListOrTransfer, title: t('local_sim.number.new.title') },
                            { component: IdentitiyCheck, title: t('steps.personal_info') },
                            { component: Check, title: t('steps.personal_info') },
                            { component: Payment, title: t('steps.personal_info') },
                        ]);
                    }
                }
                else if (simTypeId === "2") {
                    setObjs(prevObjs => {
                        const newObjs = { ...prevObjs, type: "esim" }
                        return newObjs;
                    });

                    // remove the first step
                    if (requiresNumberReservation === "false") {
                        setSteps([
                            { component: IdentitiyCheck, title: t('steps.personal_info') },
                            { component: Check, title: t('steps.personal_info') },
                            { component: Payment, title: t('steps.personal_info') },
                        ]);
                    } else {
                        setSteps([
                            { component: NumberCostumOrListOrTransfer, title: t('local_sim.number.new.title') },
                            { component: IdentitiyCheck, title: t('steps.personal_info') },
                            { component: Check, title: t('steps.personal_info') },
                            { component: Payment, title: t('steps.personal_info') },
                        ]);
                    }
                }

                const provider = await getProvider(providerId, i18n.language);
                const resolvedProvider = provider.filter((a: any) => a.id === providerId)[0];
                SetProvider(resolvedProvider);
                const plan = a.data.returnData;
                const plan_id = (await getResellerPlanId(plan.id)).returnData.resellerPlanId;
                // Entering the wizard starts a new order, so it must not inherit
                // the correlationId of an earlier order on this plan. Once per
                // mount only: this effect re-runs on a language switch, which
                // is still the same order.
                if (!correlationResetRef.current) {
                    resetCorrelationId(plan_id);
                    correlationResetRef.current = true;
                }
                setObjs(prevObjs => {
                    // provider rides along so the payment step can tag item_brand
                    const newObjs = { ...prevObjs, plan, providerId, plan_id, provider: resolvedProvider }
                    return newObjs;
                });
                setIsLoading(false);



            }).catch((e: any) => {
                console.log(e);
            });
        };


        fetchPlan();
    }, [i18n.language]);


    const [steps, setSteps] = useState<any>([
        { component: SelectType, title: t('local_sim.select_type.title') },
        { component: NumberCostumOrListOrTransfer, title: t('local_sim.number.new.title') },
        { component: IdentitiyCheck, title: t('steps.personal_info') },
        { component: Check, title: t('steps.personal_info') },
        { component: Payment, title: t('steps.personal_info') },
    ]);

    // The wizard is assembled at runtime (steps differ for port-in, eSIM and
    // plans that skip number reservation), so the step name is derived from the
    // component rather than the index.
    useEffect(() => {
        const step = stepName(steps[currentStep]?.component);
        if (step) trackCheckoutProgress(step, { number_type: objs?.bringNumber ? 'port_in' : 'new' });
        // deliberately keyed on the step only — objs changes on every answer and
        // would re-fire progress for a step the user is already on
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep, steps]);

    const addToObjs = (obj: any, next: boolean = true) => {
        setObjs(prevObjs => {
            const newObjs = { ...prevObjs, ...obj };
            return newObjs;
        });
        if (next) handleNext();
    };
    if (!token) {
        return <>   </>
    }
    const handleNext = () => {
        if (currentStep < steps.length - 1) {
            setCurrentStep(prev => prev + 1);
        }
    };

    const handlePrevious = () => {
        if (currentStep > 0) {
            setCurrentStep(prev => prev - 1);
        }
    };

    const progress = ((currentStep + 1) / steps.length) * 100;
    const discountedPlanPrice = (Number(plan?.price) || 0) - (Number(plan?.price) || 0) * (Number(plan?.discountRate) || 0);
    const totalFromFees = objs?.fees?.find((f: any) => f.type === 4)?.value;
    const totalValue = (totalFromFees !== undefined && totalFromFees !== null) ? Number(totalFromFees) : discountedPlanPrice;
    const isPaymentStep = steps[currentStep]?.component === Payment;

    // The number step carries a switch between a new number and a port-in, so
    // its heading follows the active tab rather than the title baked into the
    // step list when the wizard was assembled.
    const currentStepTitle = steps[currentStep]?.component === NumberCostumOrListOrTransfer
        ? t(objs?.bringNumber ? 'local_sim.number.transfer.title' : 'local_sim.number.new.title')
        : steps[currentStep]?.title;

    const handleBack = () => {
        setCurrentStep(prev => prev - 1);
    }
    return (
        <div className="page-container " style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            <div className="container h-100">
                <Header />
                <div className="row">
                    <div className="col-12 col-lg-8 h-100">
                        {
                            isLoading ? (
                                <div className='bg-white'>
                                    <div className="d-flex justify-content-center align-items-center h-100">
                                        <ShimmerTitle line={2} gap={10} variant="primary" />
                                    </div>
                                </div>
                            ) : currentStep > 0 && (
                                <div className="p-0 d-flex gap-4" onClick={handleBack}>
                                    <Button color="d-block p-0"
                                        isfullWidth={false} inner={
                                            <svg style={{ transform: i18n.language == "ar" ? "scaleX(-1)" : "scaleX(1)" }} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.95 31.3669C16.2666 31.3669 16.5833 31.2502 16.8333 31.0002C17.3166 30.5169 17.3166 29.7169 16.8333 29.2335L7.59997 20.0002L16.8333 10.7669C17.3166 10.2835 17.3166 9.48353 16.8333 9.0002C16.35 8.51686 15.55 8.51686 15.0666 9.0002L4.94996 19.1169C4.46663 19.6002 4.46663 20.4002 4.94996 20.8835L15.0666 31.0002C15.3166 31.2502 15.6333 31.3669 15.95 31.3669Z" fill="#292D32" />
                                                <path d="M6.1165 21.25H34.1665C34.8498 21.25 35.4165 20.6833 35.4165 20C35.4165 19.3167 34.8498 18.75 34.1665 18.75H6.1165C5.43317 18.75 4.8665 19.3167 4.8665 20C4.8665 20.6833 5.43317 21.25 6.1165 21.25Z" fill="#292D32" />
                                            </svg>
                                        }
                                    />
                                    <Button color="d-block p-0"
                                        isfullWidth={false} inner={
                                            <span>{t('global.back')}</span>
                                        }
                                    />
                                </div>

                            )}

                        {
                            !isLoading ? (
                                <>
                                    <h1 className="step-title mt-4">{currentStepTitle}</h1>
                                    <div className="progress-container mb-4 d-flex mt-4">
                                        {steps.map((_, index) => (
                                            <div
                                                key={index}
                                                className={`progress-capsule ${index <= currentStep ? 'completed' : ''}`}
                                                style={{ flex: 1, margin: '0 4px', height: '5px', borderRadius: '5px', backgroundColor: index <= currentStep ? '#3EB6AE' : 'lightgray' }}
                                            ></div>
                                        ))}
                                    </div>
                                    <div className="" style={{ height: "100%" }}>
                                        {React.createElement(
                                            steps[currentStep].component as React.ComponentType<ObjectArray>,
                                            { onOptionSelect: addToObjs as any, t, i18n, objs }
                                        )}
                                    </div></>
                            ) : (
                                <div className="d-flex justify-content-center align-items-center h-100">
                                    <ShimmerTitle line={2} gap={10} variant="primary" />
                                </div>
                            )
                        }
                    </div>
                    <div className="col-12 col-lg-4">
                        <SideInfo
                            background={provider?.imagePathLarge || plan?.imageUrl || ""}
                            backgroundColor={provider ? provider.primaryColor : ""}
                            is_bg={true}
                            elements={[
                                <div className="plan-item m-0 p-0">
                                    {
                                        !isLoading ?
                                            <>
                                                <h3>{plan.name}</h3>
                                                <span className='price_item'>{roundUpToTwoDecimals(discountedPlanPrice)} <Rs size={18} /></span>
                                            </> :
                                            <ShimmerTitle line={2} gap={10} variant="primary" />
                                    }
                                    <div className="d-flex gap-2 mt-4">
                                        {
                                            !isLoading ?
                                                <Info name={t("details.type")} logo="/media/svgs/clock_.svg" info={t(plan.contractTypeId === 1 ? t("details.prepaid") : t("details.postpaid"))} /> :
                                                <div className="w-100">
                                                    <ShimmerTitle line={2} gap={10} variant="primary" />
                                                </div>
                                        }
                                        {
                                            !isLoading ?
                                                <Info name={t("details.provider")} logo="/media/svgs/rss.svg" info={provider ? provider.name : ""} /> :
                                                <div className="w-100">
                                                    <ShimmerTitle line={2} gap={10} variant="primary" />
                                                </div>
                                        }
                                    </div>
                                </div>,
                                <Card
                                    noEdge
                                    inner={<SelectedOptions objs={objs} t={t} />}
                                    title={t('store.order_details')}
                                    title_icon="/media/svgs/list.svg"
                                    title_color="primary"
                                />,
                                ...(isPaymentStep ? [
                                <div className="table_info">
                                    <div className="d-flex title_item align-items-center gap-2">
                                        <img src="/media/svgs/list.svg" />
                                        <h6 className='m-0'>{t('store.order_details')}</h6>
                                    </div>
                                    {/* <div className="d-flex justify-content-between table_item">
                                        <span>{t('store.price')}</span>
                                        <span>{discountedPlanPrice.toFixed(2)} {t('global.sar')}</span>
                                    </div>
                                    <div className="d-flex justify-content-between table_item">
                                        <span>{t('store.quantity')}</span>
                                        <span>1</span>
                                    </div> */}
                                    {objs?.fees ? (
                                        [...objs.fees]
                                            .filter((f: any) => f.type !== 4)
                                            .sort((a: any, b: any) => (a.type === 5 ? 1 : 0) - (b.type === 5 ? 1 : 0))
                                            .map((fee: any, i: number) => (
                                                <div key={i} className="d-flex justify-content-between table_item">
                                                    <span className="d-flex align-items-center gap-2">
                                                        {fee.name}
                                                        {fee.type === 5 && (
                                                            <AiOutlineInfoCircle
                                                                size={18}
                                                                style={{ cursor: 'pointer', color: '#3EB6AE' }}
                                                                onClick={() => setShowServiceFeesInfo(true)}
                                                            />
                                                        )}
                                                    </span>
                                                    <span>{Number(fee.value).toFixed(2)} {t('global.sar')}</span>
                                                </div>
                                            ))
                                    ) : (
                                        <div className="d-flex justify-content-between table_item">
                                            <span>{t('store.fees')}</span>
                                            <span>0 {t('global.sar')}</span>
                                        </div>
                                    )}
                                    <div className="devider"></div>
                                    <div className="d-flex justify-content-between ">
                                        <span>{t('store.total')}</span>
                                        <strong className='c-primary'>
                                            {totalValue.toFixed(2)} {t('global.sar')}
                                        </strong>
                                    </div>
                                </div>
                                ] : []),
                                plan && plan.planTermsAndConditions && (
                                    <a href={plan?.planTermsAndConditions} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                        <div className="plan-terms-and-conditions d-flex justify-content-between align-items-center">
                                            <h6>{t('local_sim.plan_terms_and_conditions')}</h6>
                                            <div className='col m-0 d-flex justify-content-end align-items-center'>
                                                {i18n.language === "ar" ? <BiChevronLeft color="rgb(0, 0, 0)" size={32} /> : <BiChevronRight color="rgb(0, 0, 0)" size={24} />}
                                            </div>
                                        </div>
                                    </a>
                                )

                            ]} noBg={[1]}
                        />
                    </div>
                </div>
            </div>
            <div style={{ marginTop: "260px" }}>
                <Footer />
            </div>

            {/* Service Fees Info Modal */}
            {showServiceFeesInfo && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}
                    onClick={() => setShowServiceFeesInfo(false)}
                >
                    <div
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '24px',
                            maxWidth: '500px',
                            width: '90%',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            position: 'relative'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                            <h4 style={{ margin: 0, color: '#3EB6AE' }}>{t('store.service_fees')}</h4>
                            <button
                                onClick={() => setShowServiceFeesInfo(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#666',
                                    padding: '0',
                                    width: '30px',
                                    height: '30px'
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div style={{ lineHeight: '1.6', color: '#333' }}>
                            {i18n.language === 'ar' ? (
                                <p>
                                    يُطبَّق رسم خدمة بسيط لمرة واحدة عند تنفيذ الطلب، وذلك لدعم استمرارية الخدمة بكفاءة. <strong>لن يُدرج هذا الرسم ضمن الفواتير الشهرية لخطك.</strong>
                                </p>
                            ) : (
                                <p>
                                    A small one-time service fee is applied when placing your order to help maintain efficient service. <strong>This fee will not be included in your monthly line invoices.</strong>
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Page;
export type { ObjectArray };

interface SelectedOptionsProps {
    objs: any;
    t: any;
}

const SelectedOptions: React.FC<SelectedOptionsProps> = ({ objs, t }) => {
    console.log(objs);
    return (
        <div>
            <div className="table_info ">
                <div className="d-flex title_item align-items-center gap-2">
                    <img src="/media/svgs/list.svg" />
                    <h6 className='m-0'>{t('local_sim.title')}</h6>
                </div>
            </div>
            <ul className="selected-options-list d-flex flex-column gap-2 mt-4 mb-0">
                {Object.entries(objs).map(([key, value], index) => (
                    (key === 'type' || key === 'phone') && (
                        <li key={index} className="d-flex justify-content-between">
                            <span>{t(`local_sim.identity_check.${key}`)}</span>
                            <span>{t(`${value}`)}</span>
                        </li>
                    )
                ))}
            </ul>
        </div>
    );
};
